import styled from 'styled-components'

export const SectionLabel = styled.p`
  font-family: ${props => props.theme.fonts.robotoRegular};
  font-size: ${props => props.theme.fontSizes.section.sectionLabel};
  color: ${props => props.theme.colors.regentGray};
`
